module.exports = __webpack_public_path__ + "img/plus_button.5f3c3016.svg";